import { RectangleGroupIcon, TableCellsIcon, CalendarDaysIcon } from '@heroicons/react/20/solid';

export const COURSES_VIEWS = {
    CARDS: 'cards',
    TABLE: 'table',
    CALENDAR: 'calendar',
};

const OPTIONS = [
    { id: COURSES_VIEWS.CARDS, label: 'Tarjetas', icon: RectangleGroupIcon, title: 'Ver los cursos como tarjetas' },
    { id: COURSES_VIEWS.TABLE, label: 'Tabla', icon: TableCellsIcon, title: 'Ver los cursos en una tabla' },
    { id: COURSES_VIEWS.CALENDAR, label: 'Calendario', icon: CalendarDaysIcon, title: 'Ver clases y entregas en el calendario' },
];

/**
 * Selector único de vista para /cursos. Agrupa tarjetas, tabla y calendario en
 * un control segmentado con el aspecto de los botones de la barra
 * (`barFilterSecondary`), de modo que los filtros siguen a la vista.
 *
 * @param {{ value: string; onChange: (view: string) => void; allowTable?: boolean }} props
 */
export const CoursesViewSwitcher = ({ value, onChange, allowTable = false }) => {
    const options = OPTIONS.filter((option) => (
        option.id !== COURSES_VIEWS.TABLE || allowTable
    ));

    return (
        <div
            className='inline-flex w-full md:w-auto items-center divide-x divide-gray-300/70 overflow-hidden rounded-md bg-white shadow-sm ring-1 ring-inset ring-gray-300/80'
            role='tablist'
            aria-label='Vista de cursos'
        >
            {options.map((option) => {
                const selected = value === option.id;

                return (
                    <button
                        key={option.id}
                        type='button'
                        role='tab'
                        aria-selected={selected}
                        title={option.title}
                        onClick={() => onChange(option.id)}
                        className={`flex flex-1 items-center justify-center gap-2 px-4 py-2 text-md font-semibold transition md:flex-none focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500 ${
                            selected
                                ? 'bg-indigo-50 text-indigo-700'
                                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                        }`}
                    >
                        <option.icon className='block h-5 w-5' aria-hidden='true' />
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};
